import React from 'react';
import PropTypes from 'prop-types';
import { Line } from 'rc-progress';

const ProgressBar = ({ value, color }) => (
  <Line
    percent={value}
    strokeWidth="1"
    strokeColor={value && color}
    trailWidth="1"
    trailColor="#1E1E1E"
    strokeLinecap="square"
  />
);

ProgressBar.propTypes = {
  value: PropTypes.number.isRequired,
  color: PropTypes.string.isRequired,
};

export default ProgressBar;
